import styled from 'styled-components';

export const Content = styled.div`
  margin-top: 1rem;
`;

export const ReturnButton = styled.div`
  background: transparent;
  border: none;
  color: white;
  font-family: 'Lato';
  font-size: 1.1rem;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  & .icon {
    background-color: ${({ theme }) => theme.primary};
    border-radius: 50%;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 36px;
    width: 36px;
    margin-right: 1em;
  }

  &:hover .icon {
    background-color: ${({ theme }) => theme.primarySlightFade};
  }
`;
